import { render, staticRenderFns } from "./SuccessMessage.component.vue?vue&type=template&id=83ded366&"
import script from "./SuccessMessage.component.vue?vue&type=script&lang=ts&"
export * from "./SuccessMessage.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports